import React, {useEffect, useMemo} from 'react';
import {connect} from 'react-redux';
import {
  setSelectedSubscriber,
  setStep,
  saveToHistory,
  resetState,
  startTroubleshootingWizard,
  setProcess,
  setProcessCheckpoint,
  setClientRequestData,
  submitListResult,
  setError,
  setSelectedListResult,
} from 'app/Components/Block/AbroadTroubleshootingWizardBlock/TroubleshootingWizardSlice';
import {StepsEnum} from 'app/Components/Block/AbroadTroubleshootingWizardBlock/Enums/StepsEnum';
import {ErrorsEnum} from 'app/Components/Block/AbroadTroubleshootingWizardBlock/Enums/ErrorsEnum';
import SelectSubscriber from 'app/Components/Shared/SelectSubscriber/SelectSubscriber';
import ErrorStep from 'app/Components/Shared/ErrorStep/ErrorStep';
import {ErrorContent} from 'app/Components/Block/AbroadTroubleshootingWizardBlock/Steps/Error/ErrorContent';
import {ProcessContent} from 'app/Components/Block/AbroadTroubleshootingWizardBlock/Steps/TroubleshootingStep/ProcessContent';
import TroubleshootingStep from 'app/Components/Block/AbroadTroubleshootingWizardBlock/Steps/TroubleshootingStep/TroubleshootingStep';
import {dwhAbroadWizardEntrance} from 'app/Components/Block/AbroadTroubleshootingWizardBlock/Reports/dwhReports';

const AbroadTroubleshootingWizard = (props) => {
  const {step, troubleshootingStep, process} = props.TroubleshootingWizardSlice;
  const {setStep, setProcess, setSelectedSubscriber, startTroubleshootingWizard, contentData, setError, resetState} = props;
  const {processType} = contentData;

  const startWizard = async () => {
    if (!process) {
      setProcess(processType.value);
    }
    dwhAbroadWizardEntrance({process: processType.value});
    startTroubleshootingWizard();
  };

  const handleNoSubscriber = () => {
    setError(ErrorsEnum.NO_CELLULAR_SUBSCRIBER);
    setStep(StepsEnum.ERROR);
  };

  const handleBackButton = () => {
    window.history.back();
  }

  useEffect(() => {
    setProcess(processType.value);
    return () => {
      resetState();
    };
  }, []);

  const currentStep = useMemo(() => {
    switch (step) {
      case StepsEnum.SELECT_SUBSCRIBER:
        return (
          <SelectSubscriber
            title={'עם איזה מנוי להתקדם?'}
            onSubscriberSelect={setSelectedSubscriber}
            onSubmit={startWizard}
            onOneSubscriberAction={startWizard}
            onNoSubscriberAction={handleNoSubscriber}
          />
        );
      case StepsEnum.ERROR:
        const content = ErrorContent(props);
        return <ErrorStep content={content} epiContent={contentData} />;
      case StepsEnum.TROUBLESHOOT:
        const processContent = ProcessContent(props);
        return <TroubleshootingStep processContent={processContent} epiContent={contentData} />;
      default:
        return null;
    }
  }, [step, troubleshootingStep]);

  return <div className={'abroad-data-troubleshooting-wizard-container'}>{currentStep}</div>;
};

const mapStateToProps = (state) => {
  return {
    TroubleshootingWizardSlice: state.TroubleshootingWizardSlice,
    authentication: state.authentication,
    selfcareData: state.selfcarePage,
  };
};

const mapDispatchToProps = {
  setSelectedSubscriber,
  setStep,
  saveToHistory,
  resetState,
  startTroubleshootingWizard,
  setProcess,
  setProcessCheckpoint,
  setClientRequestData,
  setSelectedListResult,
  submitListResult,
  setError,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadTroubleshootingWizard);
